<template>
	<div class="p_flex">
		<el-select v-model="value" placeholder="请选择"><el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option></el-select>
		<div class="p_m_l_30"><el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker></div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			options: [
				{
					value: '选项1',
					label: '黄金糕'
				},
				{
					value: '选项2',
					label: '双皮奶'
				},
				{
					value: '选项3',
					label: '蚵仔煎'
				},
				{
					value: '选项4',
					label: '龙须面'
				},
				{
					value: '选项5',
					label: '北京烤鸭'
				}
			],
			value: '',
			value1: ''
		};
	},
	mounted() {},
	methods: {}
};
</script>

<style lang="scss" scoped>
>>> .el-select .el-input.is-focus .el-input__inner {
	border-color: #00af63;
}
>>> .el-select .el-input__inner:focus {
	border-color: #999999;
}
>>> .el-range-editor.is-active,
>>> .el-range-editor.is-active:hover {
	border-color: #00af63;
}
</style>



// WEBPACK FOOTER //
// src/components/homes/errors/components/head.vue